// @flow

import type { ColumnImage } from '../types';
import type { Theme, ACFRowTemplate, ACFCut } from '../../../types';

const resolvePadding = (template: ACFRowTemplate, cut: ACFCut, padding: string, theme: Theme) => (
  (template === 'hero' && cut !== 'default') ? theme.column.padding : padding
);

export const getPaddingBottom = (
  responsiveData: Object,
  padding: string,
  cutPadding: string,
  breakpoint: string,
  image: ?ColumnImage,
  rowTemplate: ACFRowTemplate,
  cut: ACFCut,
  componentsOverCut: boolean = false,
  theme: Theme,
) => {
  if (componentsOverCut) {
    return '0';
  }
  if (image && image.use_image) {
    switch (breakpoint) {
      case 'default':
      case 'sm':
      case 'md':
        return `${image.image.sizes['medium-height']}px`;
      default:
        return `calc(${responsiveData[breakpoint].hasBottom ? `${resolvePadding(rowTemplate, cut, padding, theme)} + ${cutPadding}` : theme.column.padding})`;
    }
  }

  return `calc(${responsiveData[breakpoint].hasBottom ? `${resolvePadding(rowTemplate, cut, padding, theme)} + ${cutPadding}` : theme.column.padding})`;
};

export default null;
